import { gql } from "@apollo/client";

export const ADMIN_MONTHLY_OVERVIEW = gql`
  query AdminMonthlyOverview($yearMonth: String!) {
    adminMonthlyOverview(yearMonth: $yearMonth) {
      yearMonth
      sellerAmount
      consumerFee
      totalAmount
      platformFee
      settlementAmount
      orderCount
      actualAmount
    }
  }
`;

export const ADMIN_SELLER_PLATFORM_FEES_FOR_MONTH = gql`
  query AdminSellerPlatformFeesForMonth($yearMonth: String!) {
    adminSellerPlatformFeesForMonth(yearMonth: $yearMonth) {
      sellerId
      storeId
      storeTitle
      businessNumber
      representativeName
      address
      email
      platformFeeTotal
      orderCount
    }
  }
`;

export const ADMIN_DAILY_OVERVIEW = gql`
  query AdminDailyOverview($yearMonth: String!) {
    adminDailyOverview(yearMonth: $yearMonth) {
      date
      sellerAmount
      consumerFee
      totalAmount
      platformFee
      settlementAmount
      orderCount
      actualAmount
    }
  }
`;

export const ADMIN_DAILY_ORDER_LIST = gql`
  query AdminDailyOrderList($date: String!) {
    adminDailyOrderList(date: $date) {
      id
      orderId
      storeTitle
      orderType
      sellerAmount
      consumerFee
      totalAmount
      platformFee
      settlementAmount
      soldAt
    }
  }
`;
